<template>
    <div>
        <h2>{{$t('message.dashboard_valves')}}</h2>
        <p v-html="this.$t('message.dashboard_valves_explanation')">
        </p>


        <p v-if="!loading && valves.length > 0" class="">Stav nemusí odpovídat reálnému stavu pokud dojde k ručnímu zavření / otevření vody.</p>
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th>
                    {{$t('message.homebase')}}
                </th>
                <th>
                    {{$t('message.serial_number_valve')}}
                </th>
                <th>
                    {{$t('message.name')}}
                </th>
                <th>
                    {{$t('message.status')}}
                </th>
                <th>
                    {{$t('message.signal')}}
                </th>
                <th>

                </th>
                <th>

                </th>
            </tr>
            </thead>
            <tbody>
            <template v-if="loading || valves.length === 0">
                <table-list-status :loading="loading" :colspan="7" />
            </template>
            <template v-else>
            <tr v-for="valve in valves" :key="valve.id || valve.serialNumber">
                <td>
                    <span>{{valve.homebase}}</span> <span v-if="valve.device !== 24">(CH{{valve.channel}})</span>
                    <template v-if="valve.next.length > 0">
                        <span v-for="hb of valve.next" :key="hb" style="font-size: 12px;display: block">
                            {{hb}}
                        </span>
                    </template>
                </td>
                <td>
                    {{valve.serialNumber}}
                </td>
                <td>
                  {{valve.name}}
                </td>
                <td>
                    <i class="fa fa-circle mr-1" :class="statusDotClass(valve)"></i>
                    <span v-if="!valve.loading && valve.rssi != null && valve.currentState === 'STATE_1'">{{$t('message.valve_open')}}</span>
                    <span v-if="!valve.loading && valve.rssi == null && valve.currentState === 'STATE_1'">{{$t('message.last_known_state')}}: {{$t('message.valve_open_neutral')}}</span>
                    <span v-if="loadingAction(valve) === 'closing'">{{$t('message.valve_closing')}}</span>
                    <span v-if="loadingAction(valve) === 'opening'">{{$t('message.valve_opening')}}</span>
                    <span v-if="!valve.loading && valve.rssi != null && valve.currentState === 'STATE_0'">{{$t('message.valve_closed')}}</span>
                    <span v-if="!valve.loading && valve.rssi == null && valve.currentState === 'STATE_0'">{{$t('message.last_known_state')}}: {{$t('message.valve_closed_neutral')}}</span>
                    <span v-if="!valve.loading && valve.currentState === 'STATE_4'">{{ valve.rssi != null ? $t('message.valve_half_open') : $t('message.last_known_state') + ': ' + $t('message.valve_half_open_neutral') }}</span>
                    <span v-if="!valve.loading && valve.currentState === 'STATE_3'">{{$t('message.valve_disconnected')}}</span>
                    <span v-if="!valve.loading && (valve.currentState === 'STATE_2' || !valve.currentState)">{{$t('message.valve_state_unknown')}}</span>
                    <Reason :value="valve.reason"/>
                </td>
                <td>
                    <Signal :key="'rssi-' + (valve.id || valve.serialNumber) + '-' + valve.rssi" :rssi="valve.rssi"></Signal>
                </td>
                <td class="valve-actions">
                    <div class="flex flex-wrap items-center gap-2">
                        <b-btn v-if="valve.loading" disabled type="danger">
                            <i class="fa fa-spin fa-spinner"></i>
                        </b-btn>
                        <b-btn v-if="!valve.loading && valve.currentState === 'STATE_1'" @click="close(valve)" type="danger">
                          {{$t('message.close_valve')}}
                        </b-btn>
                        <b-btn v-if="!valve.loading && (valve.currentState === 'STATE_0' || valve.currentState === 'STATE_4')" @click="open(valve)" type="success">
                          {{$t('message.open_valve')}}
                        </b-btn>
                        <b-btn v-if="!valve.loading && valve.currentState === 'STATE_4'" @click="close(valve)" type="danger">
                          {{$t('message.close_valve')}}
                        </b-btn>
                        <b-btn v-if="!valve.loading" @click="open(valve)" type="default">
                          {{$t('message.reset')}}
                        </b-btn>
                    </div>
                </td>
                <td class="valve-actions">
                  <div class="flex flex-wrap items-center gap-2">
                    <b-btn class="inline-flex items-center gap-2" :disabled="valve.saving" @click="edit(valve)"><i class="fa fa-edit"></i> {{valve.saving ? 'Ukládá se ...' : $t('message.settings')}}</b-btn>
                    <b-btn class="inline-flex items-center gap-2" @click="remove(valve)"><i class="fa fa-trash"></i> {{$t('message.remove')}}</b-btn>
                  </div>
                </td>
            </tr>
            </template>
            </tbody>
        </table>
      <EditValve ref="edit" @open="enabled=false" @close="enabled=true"/>
    </div>
</template>

<script>
    import storage, {VALVE_REQUEST} from '../_store'
    import {EditValve} from './dashboard/modal'
    import Signal from './Signal.vue'
    import Reason from './Reason.vue'
    import TableListStatus from './TableListStatus'
    import reloadInterval from '../modules/reloadInterval'

    const VALVE_REQUEST_RETRY_DELAY = 5 * 60 * 1000

    export default {
        name: 'Valves',
        mixins: [reloadInterval],
        components: {Reason, Signal, EditValve, TableListStatus},
        data () {
            return {
                enabled: true,
                loading: true,
                valves: [],
                pendingRequestSeenAt: {},
                retryingRequests: {},
                retriedUuids: {},
                apiStatusWarningShown: false
            }
        },
        methods: {
            statusDotClass (valve) {
                if (valve.rssi == null || valve.currentState === 'STATE_3' || valve.currentState === 'STATE_2' || !valve.currentState) {
                    return { gray: true }
                }
                return {
                    green: !valve.loading && valve.currentState === 'STATE_1',
                    yellow: valve.loading,
                    orange: !valve.loading && valve.currentState === 'STATE_4',
                    red: !valve.loading && valve.currentState === 'STATE_0'
                }
            },
            loadingAction (valve) {
                if (!valve || !valve.loading) {
                    return null
                }
                if (valve.currentState === 'STATE_6') {
                    return 'closing'
                }
                if (valve.currentState === 'STATE_5') {
                    return 'opening'
                }
                if (valve.requestedState === 'STATE_0') {
                    return 'closing'
                }
                if (valve.requestedState === 'STATE_1') {
                    return 'opening'
                }
                return null
            },
            edit (item) {
                this.$refs.edit.show(item)
            },
            open (valve) {
                if (valve.loading) {
                    return
                }
                storage.dispatch(VALVE_REQUEST, {
                    action: 'open',
                    homebase: valve.homebase,
                    sensor: valve.serialNumber,
                    vid: valve.id
                })
                    .then(() => {
                        valve.loading = true
                        valve.reason = 'REASON_1'
                        valve.requestedState = 'STATE_1'
                    }).catch(this.notifyError)
            },
            remove (valve) {
                if (valve.loading) {
                    return
                }
                storage.dispatch(VALVE_REQUEST, {
                    action: 'remove',
                    homebase: valve.homebase,
                    sensor: valve.serialNumber,
                    vid: valve.id
                })
                  .then(() => {
                      this.reload()
                  }).catch(this.notifyError)
            },
            close (valve) {
                if (valve.loading) {
                    return
                }
                storage.dispatch(VALVE_REQUEST, {
                    action: 'close',
                    homebase: valve.homebase,
                    sensor: valve.serialNumber,
                    vid: valve.id
                })
                    .then(() => {
                        valve.loading = true
                        valve.reason = 'REASON_1'
                        valve.requestedState = 'STATE_0'
                    }).catch(this.notifyError)
            },
            retryStaleRequests (valves) {
                const now = Date.now()
                const activeRequests = {}

                valves.forEach(valve => {
                    const pendingRequests = Array.isArray(valve.pendingRequests) ? valve.pendingRequests : []
                    pendingRequests.forEach(uuid => {
                        activeRequests[uuid] = true

                        if (!this.pendingRequestSeenAt[uuid]) {
                            this.pendingRequestSeenAt[uuid] = now
                            return
                        }
                        if (
                            now - this.pendingRequestSeenAt[uuid] < VALVE_REQUEST_RETRY_DELAY ||
                            this.retryingRequests[uuid]
                        ) {
                            return
                        }

                        this.pendingRequestSeenAt[uuid] = now
                        this.retryingRequests[uuid] = true
                        this.notifySettingResent({
                            uuid,
                            serialNumber: valve.serialNumber,
                            name: valve.name,
                            homebase: valve.homebase,
                            key: '',
                            value: ''
                        })
                        storage.dispatch(VALVE_REQUEST, {
                            action: 'retry',
                            homebase: valve.homebase,
                            sensor: valve.serialNumber,
                            vid: valve.id,
                            requestUuid: uuid
                        }).catch(this.notifyError).finally(() => {
                            delete this.retryingRequests[uuid]
                        })
                    })
                })

                Object.keys(this.pendingRequestSeenAt).forEach(uuid => {
                    if (!activeRequests[uuid]) {
                        delete this.pendingRequestSeenAt[uuid]
                        delete this.retryingRequests[uuid]
                    }
                })
            },
            notifyError (err) {
                this.$b_notify({
                    type: 'danger',
                    content: (err.response && err.response.data && err.response.data.message) || err.message || String(err)
                })
            },
            settingLabel (key) {
                const labels = {
                    currentFlowLimit: 'message.limit_current_flow',
                    continuousWaterConsumptionLimit: 'message.limit_continuous_consumption',
                    drippingLimit: 'message.limit_dripping',
                    consumptionInTimeLimitTime: 'message.limit_consumption_in_time',
                    consumptionInTimeLimitConsumption: 'message.limit_consumption_in_time'
                }
                return labels[key] ? this.$t(labels[key]) : key
            },
            valveLabel (item) {
                const name = item && item.name ? String(item.name).trim() : ''
                const serial = item && item.serialNumber ? item.serialNumber : ''
                if (name && serial && name !== serial) {
                    return name + ' (' + serial + ')'
                }
                return name || serial
            },
            notifySettingResent (item) {
                if (!item || !item.uuid || this.retriedUuids[item.uuid]) {
                    return
                }
                this.retriedUuids[item.uuid] = item
                const valve = this.valveLabel(item)
                const homebase = item.homebase || ''
                const setting = this.settingLabel(item.key)
                const value = item.value === undefined || item.value === null || item.value === '' ? '' : String(item.value)
                const content = setting
                    ? this.$t('message.valve_setting_resending', { setting, value, valve, homebase })
                    : this.$t('message.valve_setting_resending_generic', { valve, homebase })
                this.$b_notify({
                    type: 'info',
                    duration: 0,
                    content
                })
            },
            notifyCompletedSettings (valves) {
                const pending = {}
                ;(valves || []).forEach(valve => {
                    const requests = Array.isArray(valve.pendingRequests) ? valve.pendingRequests : []
                    requests.forEach(uuid => {
                        pending[uuid] = true
                    })
                })
                const byValve = {}
                Object.keys(this.retriedUuids).forEach(uuid => {
                    const item = this.retriedUuids[uuid]
                    const key = item.serialNumber || item.name || uuid
                    if (!byValve[key]) {
                        byValve[key] = { item, uuids: [] }
                    }
                    byValve[key].uuids.push(uuid)
                })
                Object.keys(byValve).forEach(serial => {
                    const group = byValve[serial]
                    const stillPending = group.uuids.some(uuid => pending[uuid])
                    if (stillPending) {
                        return
                    }
                    this.$b_notify({
                        type: 'success',
                        duration: 0,
                        content: this.$t('message.valve_setting_applied', {
                            valve: this.valveLabel(group.item)
                        })
                    })
                    group.uuids.forEach(uuid => {
                        delete this.retriedUuids[uuid]
                    })
                })
            },
            reload () {
                if (!this.enabled || this.reloadStopped) {
                    return
                }
                storage.dispatch(VALVE_REQUEST)
                    .then(resp => {
                        this.valves = resp.data.data
                        if (resp.data.statusFresh === false) {
                            if (!this.apiStatusWarningShown) {
                                this.$b_notify({
                                    type: 'warning',
                                    content: this.$t('message.valve_status_may_be_stale')
                                })
                                this.apiStatusWarningShown = true
                            }
                        } else {
                            this.apiStatusWarningShown = false
                        }
                        const retried = Array.isArray(resp.data.retriedRequests) ? resp.data.retriedRequests : []
                        retried.forEach(item => this.notifySettingResent(item))
                        this.notifyCompletedSettings(this.valves)
                        this.retryStaleRequests(this.valves)
                    }).catch(err => {
                        this.$b_notify({
                            type: 'danger',
                            content: err
                        })
                    }).finally(() => {
                        this.loading = false
                    })
            }
        },
        mounted () {
            this.reload()
            this.startReloadInterval(() => this.reload())
        },
        activated () {
            this.startReloadInterval(() => this.reload())
        }
    }
</script>

<style scoped>
  .green {
    color: green;
  }
  .red {
    color: red;
  }
  .yellow {
    color: yellow;
  }
  .orange {
    color: #f0ad4e;
  }
  .gray {
    color: gray;
  }
</style>
